var _path, _path2, _ellipse, _ellipse2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 87,
    viewBox: "0 0 78 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 10.3923L56.7846 12L71.5692 34.3923L41.5692 86.3538L0 62.3538L30 10.3923Z",
    fill: "#404C8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7846 32.7846L45.8915 41.5825L54.1031 44.9287L48.6648 51.9325L52.1051 60.1051L43.3073 61.2121L39.961 69.4236L32.9572 63.9853L24.7846 67.4256L23.6777 58.6278L15.4661 55.2815L20.9044 48.2777L17.4641 40.1051L26.2619 38.9982L29.6082 30.7866L36.612 36.2249L44.7846 32.7846Z",
    fill: "#758BFD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9258,
    cy: 58.0964,
    rx: 3.15,
    ry: 3.15,
    transform: "rotate(30 36.9258 58.0964)",
    stroke: "#F1F2F6",
    strokeWidth: 3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6434,
    cy: 42.1139,
    rx: 3.15,
    ry: 3.15,
    transform: "rotate(30 32.6434 42.1139)",
    stroke: "#F1F2F6",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0788 46.8109L22.4904 53.3994",
    stroke: "#F1F2F6",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.2846,
    cy: 21.5263,
    r: 5,
    transform: "rotate(30 51.2846 21.5263)",
    fill: "#AEB8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.adab135f16840fef833bda110b9886cd.svg";
export { ForwardRef as ReactComponent };